import axios from 'axios'
import config from '@/config'
import { decomposeUrlParams } from '../utils'

const loginService = {
  postLogin(context, jObject) {
    return new Promise((resolve, reject) => {
      let username = jObject.Username
      let password = jObject.Password
      let credentials = btoa(username + ':' + password)
      let BasicAuth = 'Basic ' + credentials
      // let isProd = config.ISPROD
      axios({
        method: 'POST',
        url: `${config.BASE_API_LOGIN_URL}/login${jObject.skipValidation ? '?skipEmailValidation=true' : ''}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: BasicAuth
        }
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  postForgotPassword(context, jObject) {
    return new Promise((resolve, reject) => {
      axios
        .post('/forgotpassword', jObject)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  postNewPassword(context, newPassword) {
    let params = decomposeUrlParams(window.location.search)
    let esc = encodeURIComponent
    let queryString = Object.keys(params)
      .map(key => esc(key) + '=' + esc(params[key]))
      .join('&')
    return new Promise((resolve, reject) => {
      axios
        .post('/newpassword' + '?' + queryString, {
          password: newPassword
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  postEditName(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/updatename',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  postCandEditEmail(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/candidate/updateemail',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  postEditPassword(context, data, url) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_LOGIN_URL + '/resetpassword',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getRecruiterInfo(context) {
    return new Promise((resolve, reject) => {
      // For error in /recruiter/info in candidate-profiles page
      let token = localStorage.getItem('_verificationToken')
      if (!token) {
        resolve(null)
        return
      }
      axios({
        method: 'GET',
        url: '/registration/recruiter/info'
      })
        .then(response => {
          localStorage.setItem('recInfo', JSON.stringify(response.data))
          if(response.data.corporateInfo) {
            context.dispatch('adminPanelModule/setCICompanyInfo', response.data.corporateInfo, {root:true})
          } else {
            context.dispatch('adminPanelModule/setCICompanyInfo', null, {root:true})
          }
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  postRecEditEmail(context, data, url) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/recruiter/updateemail',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  inviteRecTeamMem(context, data, url) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/recruiter/invite/multiple',
        data: data
      })
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getRecruiterList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/registration/recruiter/list'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  removeRecUser(context, data, url) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/recruiter/removeuser',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  recruiterCompanyList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/industrylist/en'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  companyUpdate(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/recruiter/company/update',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  sendMail(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/sendmail',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateCompanyLogo(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/recruiter/company/updatelogo',
        data: data
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  logOut(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_LOGIN_URL + '/logout'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  deleteLogo(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/registration/recruiter/company/deletelogo'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  pendingListApi(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/registration/recruiter/listpending '
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  }
}
export default loginService
